import { axiosInstance, ENDPOINT } from 'common/constants';
import { handleResponse } from 'common/helpers';

// Data fetchers for the asset-type / machine-sub-type pickers. Kept out of the
// components per the codebase pattern (API calls live in actions/services).
// No manual response cache — the browser HTTP cache handles repeat GETs.

export const ASSET_TYPE_FALLBACK = ['rotating', 'non_rotating'];

// Machine "asset types" (rotating / non_rotating) from the builder metadata.
export function fetchAssetTypes() {
  return handleResponse(axiosInstance.get(ENDPOINT.GET_MACHINES_BUILDER_METADATA))
    .then((data) => {
      const types = (data && data.asset_types) || [];
      return types.length ? types : ASSET_TYPE_FALLBACK;
    })
    .catch(() => ASSET_TYPE_FALLBACK);
}

// Global, analyst-extensible machine sub-type vocabulary.
export function fetchMachineSubTypes() {
  return handleResponse(axiosInstance.get(ENDPOINT.MACHINE_SUB_TYPES)).then(list => list || []);
}

export function createMachineSubType(name, assetType) {
  const body = assetType ? { name, asset_type: assetType } : { name };
  return handleResponse(axiosInstance.post(ENDPOINT.MACHINE_SUB_TYPES, body));
}
